import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Design",
  "description": "",
  "published": "2007-01-23T00:00:00.000Z",
  "redirect_from": ["/blog/design/swizec/311"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Some websites out there simply have a fascinating and breath taking design. They are few and far between and nonsurprisingly almost always a personal website of some graphic artist trying to make themselves known or simply to share their stuff. `}<a parentName="p" {...{
        "href": "http://www.mariawilliam.net/"
      }}>{`Maria J. Williams`}</a>{` seems to be one such person. The website is simply the best design I've ever had the honour of noticing.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      